import { useEffect, useState } from 'react';
import styled from 'styled-components';
import client from '../api/client';
import Card from '../components/ui/Card';
import { Contenedor, TituloPagina, Subtitulo } from '../components/layout/Layout';

const Historia = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.xl};
  grid-template-columns: 1fr;
  margin-bottom: ${({ theme }) => theme.space.xxl};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }

  p {
    color: ${({ theme }) => theme.colors.textMuted};
    margin-bottom: ${({ theme }) => theme.space.md};
  }
`;

const Bloque = styled.div`
  background: ${({ theme }) => theme.colors.sageLight};
  border-radius: ${({ theme }) => theme.radii.lg};
  padding: ${({ theme }) => theme.space.xl};

  h2 {
    color: ${({ theme }) => theme.colors.sageDeep};
    font-size: 1.5rem;
    margin-bottom: ${({ theme }) => theme.space.md};
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.space.sm};
  }

  li {
    padding-left: 1.4rem;
    position: relative;
    color: ${({ theme }) => theme.colors.text};

    &::before {
      content: '—';
      position: absolute;
      left: 0;
      color: ${({ theme }) => theme.colors.sage};
    }
  }
`;

const Equipo = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.lg};
  grid-template-columns: 1fr;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Instructor = styled(Card)`
  text-align: center;

  h3 {
    font-size: 1.1rem;
    margin-top: ${({ theme }) => theme.space.sm};
  }

  p {
    font-size: 0.88rem;
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const Inicial = styled.div`
  width: 72px;
  height: 72px;
  margin: 0 auto;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.sage};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.7rem;
`;

const TituloEquipo = styled.h2`
  text-align: center;
  color: ${({ theme }) => theme.colors.sageDeep};
  font-size: 1.7rem;
  margin-bottom: ${({ theme }) => theme.space.xl};
`;

function Nosotros() {
  const [instructores, setInstructores] = useState([]);

  useEffect(() => {
    client.get('/instructores').then(({ data }) => setInstructores(data)).catch(() => {});
  }, []);

  return (
    <Contenedor>
      <TituloPagina>Nosotros</TituloPagina>
      <Subtitulo>
        Una sola sucursal y una manera muy particular de entender el movimiento: consciente, sin
        prisa y siempre acompañado.
      </Subtitulo>

      <Historia>
        <div>
          <p>
            Numa nació en 2019 con dos camas reformer y una convicción simple: en un salón lleno de
            gente nadie corrige tu postura. Seguimos siendo, a propósito, un estudio pequeño —
            grupos reducidos, luz natural y una comunidad que se conoce por su nombre, no por un
            número de folio.
          </p>
          <p>
            Para nosotros el pilates es una práctica de fondo, no una moda de temporada: fuerza de
            centro, respiración y control antes que velocidad. Cada clase se ajusta a quien la
            toma, desde tu primera sesión de mat hasta el trabajo terapéutico más específico.
          </p>
        </div>
        <Bloque>
          <h2>Nuestra filosofía</h2>
          <ul>
            <li>Grupos reducidos para corregir cada postura</li>
            <li>Progreso sin dolor y sin prisa</li>
            <li>Tu clase, una pausa real en el día — no una obligación más</li>
            <li>Seguimos tu proceso clase a clase, no solo tu asistencia</li>
          </ul>
        </Bloque>
      </Historia>

      {instructores.length > 0 && (
        <>
          <TituloEquipo>Quiénes te acompañan</TituloEquipo>
          <Equipo>
            {instructores.map((i) => (
              <Instructor key={i.id}>
                {i.foto_url ? (
                  <img
                    src={i.foto_url}
                    alt={`Foto de ${i.nombre}`}
                    style={{ width: 72, height: 72, borderRadius: '50%', margin: '0 auto', objectFit: 'cover' }}
                  />
                ) : (
                  <Inicial aria-hidden="true">{i.nombre.charAt(0)}</Inicial>
                )}
                <h3>{i.nombre}</h3>
                <p>{i.especialidad}</p>
              </Instructor>
            ))}
          </Equipo>
        </>
      )}
    </Contenedor>
  );
}

export default Nosotros;
